import { render, staticRenderFns } from "./Svg03Section05.vue?vue&type=template&id=2a9a3af4&"
import script from "./Svg03Section05.vue?vue&type=script&lang=js&"
export * from "./Svg03Section05.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports